import { api } from "@/lib/api";

const PREVIEW = /(\.preview\.emergentagent\.com|\.preview\.emergentcf\.cloud|localhost|127\.0\.0\.1)$/;
let serverUrl = null;

export const isPreviewOrigin = (origin = window.location.origin) => PREVIEW.test(new URL(origin).hostname);

export function loadSiteUrl() {
  return api.get("/site").then((r) => { serverUrl = r.data.url; }).catch(() => {});
}

// Public website address used for client links: the live site you're on, or the saved live address when on preview.
export function siteUrl() {
  if (!isPreviewOrigin() || !serverUrl) return window.location.origin;
  return serverUrl;
}
